<template>
    <paper id="threeplBillingOrder">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :currentPage="searchParams.pageNo"
            :searchTotalTitle="searchTotalTitle"
            @saveData="saveData"
            @row-db-click="rowDBclick"
            @getTableConfigList="getTableConfigList"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @switch-change="switchChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @search-list-change="searchListChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_TPLORDER_ROUTE">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="''" class="mgl-10">
                            <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
            </div>
        </m-pane>
    </paper>
</template>

<script>
import mPane from '@/components/otpPanel';
import config from './config';
import paper from '@/components/core/paper/Paper';
import { getTplCostRouteInfos } from '@otp/api/threeplOrderRouter';
// import lotsButton from '@/components/lots/lotsButton';
import dayjs from 'dayjs';
import reportExport from '@/components/lots/reportExportPlugin';
import { mapState } from 'vuex';

export default {
    name: 'threeplOrderRouter',
    components: { mPane, paper, reportExport },
    data() {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            visible: false,
            dialog: config.dialog,
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            selectedRows: [],
            aginNodeData: {}
        };
    },
    methods: {
        changeDateFormat(arr) {
            arr = arr || [];
            arr.forEach((item, index) => {
                arr[index] = dayjs(item).format('YYYY-MM-DD HH:mm:ss');
            });
            return arr;
        },
        toFirstPage() {
            this.searchParams.pageNo = 1;
            this.getList();
        },
        getList() {
            this.timeFormat();
            const params = Object.assign({}, this.searchParams);
            const msg = this.searchLimit(params);
            if (msg) {
                this.$message.warning(msg);
                return;
            }
            this.deleteNullSearchParams(params);
            Reflect.deleteProperty(params, 'createTime');

            this.loading = true;
            getTplCostRouteInfos(params).then(res => {
                if (res && res.code === '0') {
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        searchLimit(params) {
            if (!params.createTime && !params.customerOrderNo) {
                return '客户订单号 或 时间不可为空！';
            }
        },
        deleteNullSearchParams(searchParams) {
            for (const key in searchParams) {
                if (!searchParams[key]) {
                    delete searchParams[key];
                }
            }
        },
        rowDBclick(row) {
            // 表格内双击事件
        },
        checkBtn(data) {
            // 表格内按钮查看事件;
            this.visible = true;
        },
        editBtn(data) {
            // 表格内按钮修改事件;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectedRows = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchListChange(config, data) {
            this.searchParams[config.value] = data || '';
        },
        searchChange(data) {
            // 提交搜索框
            this.searchParams = { ...this.searchParams, ...data };
            this.searchParams.pageNo = 1;
            this.getList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getList();
        },
        timeFormat() {
            let { createTime } = this.searchParams;
            if (createTime) {
                createTime = this.changeDateFormat(createTime);
                this.searchParams.createStartTime = createTime[0];
                this.searchParams.createEndTime = createTime[1];
            }
        },
        addData() {
            // 表格新增方法
            this.$refs.tablePage.$refs.table.addRow();
        },
        saveData(data) {
        },
        getTableConfigList(data) {},
        refresh() {
            // 表格内刷新按钮
        },
        adddatail() {
            this.$refs.transTable.showDialog();
        },
        getUploadResult(flag) {
            if (flag) {
                this.getList();
            }
        },
        checkSelectRow() {
            if (!this.selectedRows.length) {
                this.$message.warning('请选择数据');
                return true;
            }
        },
        // 导出
        exportFile(submit) {
            // 列表数据为空导出时处理
            const tableLength = this.totalData.length;
            if (!tableLength) {
                this.$refs.tablePage.$refs.searchList.onSearchChange();
            }
            this.timeFormat();
            const exportParams = Object.assign({}, this.searchParams);
            const msg = this.searchLimit(exportParams);
            // 有数据时需要弹出，无数据时不用弹出
            if (msg) return tableLength ? this.$message.warning(msg) : '';
            submit({ ...exportParams, tenantCode: this.currentTenant.tenantCode });
        }
    },
    computed: {
        ...mapState(['user', 'currentTenant'])
    },
    created() {
    }
};
</script>
<style lang="less">
</style>
